import { cn } from '@/lib/cn';

interface PageContainerProps {
  children: React.ReactNode;
  /** Дополнительные классы корневого элемента (например, flex-раскладка страницы) */
  className?: string;
}

/**
 * Единая колонка контента страницы: одинаковые отступы от краёв области
 * контента у всех страниц — списков и карточек редактирования.
 * mx-auto + max-w-6xl центрируют колонку на широких экранах; на узких
 * контейнер занимает всю область (p-6 из AppLayout).
 */
export function PageContainer({ children, className }: PageContainerProps) {
  return <div className={cn('mx-auto w-full max-w-6xl', className)}>{children}</div>;
}
